import { useEffect } from 'react';
import { initializeMetaPixel, isMetaPixelLoaded } from '../utils/metaPixel';

/**
 * Meta Pixel component that handles initialization
 * This component should be included once in your app
 */
export const MetaPixel = () => {
  useEffect(() => {
    let retryCount = 0;
    const maxRetries = 50; // Max 5 seconds of retrying (50 * 100ms)
    let timeoutId: number | undefined;

    // Initialize Meta Pixel when component mounts
    const initPixel = () => {
      if (isMetaPixelLoaded()) {
        initializeMetaPixel();
      } else if (retryCount < maxRetries) {
        // Retry if pixel script hasn't loaded yet
        retryCount++;
        timeoutId = window.setTimeout(initPixel, 100);
      } else {
        console.warn('Meta Pixel failed to load after maximum retries');
      }
    };

    // Start initialization
    initPixel();

    // Cleanup timeout on unmount
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  // This component doesn't render anything
  return null;
};

/**
 * Meta Pixel Script component
 * Renders the noscript fallback for users with JavaScript disabled
 */
export const MetaPixelNoscript = () => {
  return (
    <noscript>
      <img 
        height="1" 
        width="1" 
        style={{ display: 'none' }}
        src="https://www.facebook.com/tr?id=1417518489322657&ev=PageView&noscript=1"
        alt=""
      />
    </noscript>
  );
};
